import { React, useEffect, useState } from "react";
import { postDatatoQueryParams } from "../../function/FunctionApi";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../Image/logo.png";
import logo2 from "../../Image/image-removebg-preview (1) 1.png";
import backgroundImage from "../../Image/loginside.jpeg";
import {
  setUserSession,
  isUserSessionValid,
} from "../../function/AuthStorage"; 
import "./Login.css";

// ─── Mapping: permission → أول route مناسب ────────────────────────────────
const PERM_ROUTE_MAP = [
  { perm: "Construction.View",   route: "/search-requests" },
  { perm: "Emergency.View",      route: "/search-requests" },
  { perm: "Maintenance.View",    route: "/search-requests" },
  { perm: "NewProject.View",     route: "/search-requests" },
  { perm: "PrivateProject.View", route: "/all-admin-private-project" },
  { perm: "Users.View",          route: "/accounts" },
  { perm: "Employees.View",      route: "/employees" },
  { perm: "Branch.View",         route: "/branches" },
  { perm: "Office.View",         route: "/offices" },
  { perm: "Custody.View",        route: "/custodies" },
  { perm: "Attendance.View",     route: "/check-attendance" },
  { perm: "LeaveRequest.View",   route: "/vacations" },
  { perm: "Notifications.View",  route: "/notification" },
  { perm: "Neighborhood.View",   route: "/district" },
  { perm: "Consultant.View",     route: "/consultants" },
  { perm: "WorkOrderType.View",  route: "/tasktype" },
];

// بتحدد أول صفحة يروح عليها المستخدم بعد اللوجين
function getRedirectAfterLogin(userData) {
  const { userType, permissions = [] } = userData;

  if (userType === "admin")         return "/home-page";
  if (userType === "supervisor")    return "/home-page";
  if (userType === "officeManager") return "/home-page";
  if (userType === "eng")           return "/main-page";
  if (userType === "contractor")    return "/projects";

  // supervisor / officeManager → أول route عنده صلاحية عليه
  for (const { perm, route } of PERM_ROUTE_MAP) {
    if (permissions.includes(perm)) return route;
  }

  // مفيش صلاحيات خالص
  return "/no-access";
}

function Login({ setUserData }) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [data, setData] = useState({
    UserName: "",
    Password: "",
  });

  useEffect(() => {
    if (isUserSessionValid()) {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const location = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            resolve({ latitude, longitude });
          },
          (error) => {
            reject(error);
          }
        );
      });

      localStorage.setItem("userLocation", JSON.stringify(location));

      const result = await postDatatoQueryParams(
        "Account/login",
        data,
        setError
      );

      if (result) {
        // مانخزّنش الباسورد على الفرونت أبدًا، حتى لو السيرفر رجّعه بالغلط
        const { password, ...safeUserData } = result.data;

        const saved = setUserSession(safeUserData);
        if (!saved) {
          setError("حدث خطأ أثناء حفظ جلسة الدخول. حاول مرة أخرى.");
          return;
        }

        setUserData(safeUserData);

        const userType = safeUserData.userType;
        localStorage.setItem("userType", userType);
        localStorage.setItem("IsRiyadh", safeUserData.branchName !== "جدة");
        localStorage.setItem("isAllowed", safeUserData.userCanCreateProjectOutsideCityType);
        localStorage.setItem("branchId", safeUserData.branchId);

        // ── redirect بناءً على الصلاحيات ──────────────────────────────
        navigate(getRedirectAfterLogin(safeUserData));
      }
    } catch (error) {
      if (error.code === error.PERMISSION_DENIED) {
        console.log("error", error);
        setError(error.response?.data?.message);
      } else {
        const errorMessage =
          error.response?.data?.message || "البيانات غير صحيحة، حاول مرة أخرى";
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (

   <div className="Login" dir="rtl">
  <div className="image-container">
    <img
      src={backgroundImage}
      alt="Background"
      className="background-image"
    />
    {/* تم حذف اللوجو من هنا */}
  </div>

  <div className="form-container">
 <div className="w-full flex justify-center mb-4">
  <img
    src={logo}
    alt="Logo"
    className="logo-left"
  />
</div>

  <h2>أهلا بكم في عصف</h2>

  <form onSubmit={handleFormSubmit} dir="rtl">
    <label htmlFor="UserName">اسم المستخدم</label>
    <input
      type="text"
      id="UserName"
      value={data.UserName}
      onChange={handleChange}
      disabled={loading}
    />

    <label htmlFor="Password">كلمة المرور</label>
    <div style={{ position: "relative" }}>
      <div style={{ position: "relative" }}>
        <input
          type={showPassword ? "text" : "password"}
          id="Password"
          value={data.Password}
          onChange={handleChange}
          disabled={loading}
          style={{
            width: "100%",
            paddingRight: "2.5rem",
            boxSizing: "border-box",
          }}
        />
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          disabled={loading}
          style={{
            position: "absolute",
            left: "0.75rem",
            top: "-10%",
            transform: "translateY(-10%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            color: "#888",
          }}
        >
          {showPassword ? "اخفاء" : "اظهار"}
        </button>
      </div>
    </div>

    <button type="submit" className="!bg-mainColor" disabled={loading}>
      {loading ? "جاري تسجيل الدخول" : "تسجيل دخول"}
    </button>

    <div className="text-center mt-4">
      <Link
        to="/reset-password"
        className="text-mainColor hover:text-mainColor-dark"
      >
        نسيت كلمة المرور؟
      </Link>
    </div>

    {error && <p className="error-message">{error}</p>}
  </form>
</div>
 </div>

  );
}

export default Login;